import React, {PureComponent, ReactNode} from "react"
import {connect} from "react-redux"

import AppContainer from "@irati/ui/src/AppContainer"
import intercom from "@irati/utils/intercom"
import ReduxState from "@irati/store/types/ReduxState"
import {Tenant} from "@irati/types"

import {DesktopOnlySupported} from "../../components"
import {PartialGrid} from "../../components/styled"

interface Props {
  updateAuthTenant: (tenant: Tenant) => void,
  isMobile?: boolean,
  children?: ReactNode
}

class TenantOnboardingContainer extends PureComponent<Props> {
  componentDidMount = () => intercom.hide()
  componentWillUnmount = () => intercom.show()

  render() {
    const {isMobile, children} = this.props

    return (
      <AppContainer hasFooter={false} isFlush>
        <PartialGrid>
          {isMobile && <DesktopOnlySupported />}
          {!isMobile && children}
        </PartialGrid>
      </AppContainer>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => ({
  isMobile: mq.lessThan.medium
})

export default connect(mapStateToProps)(TenantOnboardingContainer)
